/* SpawnAnything — "Meine Sammlung": the player's own AI figures and buildings, kept permanently (localStorage for now;
   with server accounts this moves to the account). Entries: { id, kind: 'unit' | 'building', name, prompt, recipe,
   created }. main.js registers every entry as a unit type / building at start-up, so saved creations show up in the
   army and build windows next to the built-in ones. Pure data module: no DOM, testable in Node. */

const KEY = 'aw-collection';
const MAX = 200;
const listeners = new Set();
let items = null;

function store() { try { return globalThis.localStorage || null; } catch (e) { return null; } }
function load() {
  if (items) return items;
  items = [];
  const s = store(); if (!s) return items;
  try { const a = JSON.parse(s.getItem(KEY) || '[]'); if (Array.isArray(a)) items = a.filter(valid).slice(0, MAX); } catch (e) { items = []; }
  return items;
}
function save() {
  const s = store(); if (!s) return false;
  try { s.setItem(KEY, JSON.stringify(items)); return true; } catch (e) { return false; } // quota: the newest entry is not kept
}
const valid = e => e && typeof e.id === 'string' && (e.kind === 'unit' || e.kind === 'building') && e.recipe && typeof e.recipe === 'object' && typeof e.name === 'string';
const emit = () => { for (const f of listeners) f(items); };
// stable key for "same recipe" (no double entries when the same figure is saved twice)
const sig = r => { try { return JSON.stringify(r); } catch (e) { return ''; } };

export const collection = {
  /** all entries, optionally of one kind, newest first */
  list(kind) { const a = load(); return (kind ? a.filter(e => e.kind === kind) : a).slice().sort((x, y) => y.created - x.created); },
  get(id) { return load().find(e => e.id === id) || null; },
  /** true if this recipe is already saved */
  has(kind, recipe) { const s = sig(recipe); return load().some(e => e.kind === kind && sig(e.recipe) === s); },
  /** saves a creation; returns the entry (the existing one if the same recipe is already in the collection) */
  add({ kind, name, prompt = '', recipe }) {
    load();
    const s = sig(recipe), old = items.find(e => e.kind === kind && sig(e.recipe) === s);
    if (old) return old;
    const e = { id: kind[0] + Date.now().toString(36) + Math.random().toString(36).slice(2, 6), kind, name: String(name || 'Eigene Kreation').slice(0, 60), prompt: String(prompt).slice(0, 160), recipe, created: Date.now() };
    if (!valid(e)) return null;
    items.unshift(e); if (items.length > MAX) items.length = MAX;
    if (!save()) { items.shift(); return null; }
    emit(); return e;
  },
  remove(id) { load(); const i = items.findIndex(e => e.id === id); if (i < 0) return false; items.splice(i, 1); save(); emit(); return true; },
  /** replaces an entry's recipe in place (a repaired version of the same figure, see recipeRepair.js); no listeners */
  setRecipe(id, recipe) { const e = this.get(id); if (!e || !recipe || typeof recipe !== 'object') return false; e.recipe = recipe; return save(); },
  rename(id, name) { const e = this.get(id); if (!e) return false; e.name = String(name).slice(0, 60); save(); emit(); return true; },
  /** listener(items) after every change; returns an unsubscribe function */
  subscribe(f) { listeners.add(f); return () => listeners.delete(f); },
  /** tests: forget the cached copy */
  _reset() { items = null; },
};
